'use client';

import type { ReactNode } from 'react';
import { Box } from '@terra/ui-styled-system';
import { BodyStrong, Scroll, Tabs } from '@terra/ui-design-system';
import { useTranslations } from 'next-intl';
import { ExecutionAuditLogTab } from './ExecutionAuditLogTab';

type ExecutionTraceTabsProps = {
  overview: ReactNode;
  applicationId: string;
  threadId: string | undefined;
  executionStatus: 'running' | 'completed' | 'error' | 'aborted';
  isAttackSkipped?: boolean;
  activeTab: string;
  onActiveTabChange: (tab: string) => void;
  onNavigateToToolCall?: (toolCallId: string) => void;
};

export function ExecutionTraceTabs({
  overview,
  applicationId,
  threadId,
  executionStatus,
  isAttackSkipped = false,
  activeTab,
  onActiveTabChange,
  onNavigateToToolCall,
}: ExecutionTraceTabsProps) {
  const t = useTranslations('expectedResponseObservations');

  return (
    <Tabs.Root
      value={activeTab}
      onValueChange={({ value }) => onActiveTabChange(value)}
      size="sm"
      w="full"
      h="full"
      display="flex"
      flexDirection="column"
      overflow="hidden"
      lazyMount
    >
      <Tabs.List justifyContent="flex-start" px="4">
        <Tabs.Trigger value="overview" py="0">
          <BodyStrong as="span">{t('tabs.overview')}</BodyStrong>
        </Tabs.Trigger>
        <Tabs.Trigger value="audit-log" py="0">
          <BodyStrong as="span">{t('title')}</BodyStrong>
        </Tabs.Trigger>
        <Tabs.Indicator />
      </Tabs.List>

      <Tabs.Content value="overview" flex="1" overflow="hidden" pt="0">
        <Box h="full" overflow="hidden">
          {overview}
        </Box>
      </Tabs.Content>

      <Tabs.Content value="audit-log" flex="1" overflow="hidden" pt="0">
        <Box h="full" overflow="hidden">
          <Scroll orientation="vertical" showScrollbar>
            <Box p="4">
              <ExecutionAuditLogTab
                applicationId={applicationId}
                threadId={threadId}
                executionStatus={executionStatus}
                isAttackSkipped={isAttackSkipped}
                onNavigateToToolCall={onNavigateToToolCall}
              />
            </Box>
          </Scroll>
        </Box>
      </Tabs.Content>
    </Tabs.Root>
  );
}
